import React, { MutableRefObject } from 'react'
import { connect } from 'react-redux'
import { RootState } from 'duck'
import { ReduxProps } from 'utils/Types'
import InfoCurateCollection from './InfoCurateCollection'
import ImagesList from './ImageList'
import { selectors, STEP } from 'containers/NFTSellPanel/duck'

const mapStateToProps = (state: RootState) => ({
  step: selectors.step(state)
})

type CurateCollectionProps = ReduxProps<typeof mapStateToProps> & {
  dialogBodyRef?: MutableRefObject<any>
}

const CurateCollection: React.FC<CurateCollectionProps> = props => {
  const { dialogBodyRef, step } = props
  return (
    <>
      {step === STEP.CURATE_INFO ? <InfoCurateCollection /> : null}
      {step === STEP.CURATE_COLLECTION || step === STEP.SELECT_COVER ? (
        <ImagesList dialogBodyRef={dialogBodyRef} />
      ) : null}
    </>
  )
}

export default connect(mapStateToProps)(CurateCollection)
